exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#link-file-dropzone[data-v-2092f890]{min-height:126px}#link-file-add-files[data-v-2092f890]{padding-top:45px}.dz-uploaded-file[data-v-2092f890]{cursor:default}#link-file-add-more-files[data-v-2092f890]{position:absolute;left:15px;bottom:16px}.progress-display[data-v-2092f890]{position:absolute;left:15px;bottom:10px;width:calc(100% - 100px)}", ""]);

// exports
